import React, { useState } from 'react';
import { AnimatedBackground, ModernCard } from '../ui/modern';
import SectorsManager from './SectorsManager';
import TaskTemplatesManager from './TaskTemplatesManager';
import EntityTypeManager from './EntityTypeManager';
import FormBuilder from './FormBuilder';

const TABS = [
  { key: 'sectors', label: 'Sectors', icon: '🏷️' },
  { key: 'templates', label: 'Templates', icon: '🧩' },
  { key: 'entity-types', label: 'Entity Types', icon: '📦' },
  { key: 'form-builder', label: 'Form Builder', icon: '📝' },
];

export default function ManagementConsole({ user }) {
  const isAdmin = user?.role === 'Admin';
  const [tab, setTab] = useState('sectors');

  if (!isAdmin) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gradient-to-br dark:from-slate-900 dark:via-slate-800 dark:to-slate-900 p-6">
        <AnimatedBackground />
        <div className="relative z-10 max-w-4xl mx-auto">
          <ModernCard>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">Management Console</h1>
            <p className="text-gray-600 dark:text-slate-300">You don't have permission to view this page.</p>
          </ModernCard>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gradient-to-br dark:from-slate-900 dark:via-slate-800 dark:to-slate-900 p-6">
      <AnimatedBackground />

      <div className="relative z-10 max-w-7xl mx-auto space-y-6">
        <ModernCard>
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div>
              <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Management Console</h1>
              <p className="text-gray-600 dark:text-slate-400">Manage sectors and task templates (admin only)</p>
            </div>
          </div>
        </ModernCard>

        <div className="flex gap-3 overflow-x-auto pb-1 -mx-1 px-1">
          {TABS.map((t) => (
            <button
              key={t.key}
              onClick={() => setTab(t.key)}
              className={`px-4 py-3 rounded-2xl font-semibold transition-all border flex-shrink-0 ${
                tab === t.key
                  ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white border-blue-500/20 shadow-lg shadow-blue-500/25'
                  : 'bg-white dark:bg-white/5 text-gray-700 dark:text-slate-300 hover:bg-gray-100 dark:hover:bg-white/10 border-gray-200 dark:border-white/10'
              }`}
            >
              <span className="mr-2">{t.icon}</span>
              {t.label}
            </button>
          ))}
        </div>

        {tab === 'sectors' && <SectorsManager />}
        {tab === 'templates' && <TaskTemplatesManager />}
        {tab === 'entity-types' && <EntityTypeManager />}
        {tab === 'form-builder' && <FormBuilder />}
      </div>
    </div>
  );
}


